<script setup>
import {
    __FIELD_TYPE_UPLOAD__,
    __FIELD_TYPE_SELECT__,
    __FIELD_TYPE_DATE__,
    __FIELD_TYPE_CHECKBOX__,
} from "@/const/fieldType";
import { __CMP_OPT_IN__ } from "@/const/csrCmpName";
import { usePreviewFiles,useBrand } from "@/hooks/common/useUtils";
import Dayjs from "dayjs";

const props = defineProps({
    formats: {
      type: Object,
      default: null
    },
    state: {
      type: Object,
      default: null
    },
});

const getValue = ({ value, conf, cmp }) => {
    const { formats } = props;
    const { fieldType, multiple, dataSource } = conf;
    // 优先使用format函数进行转换
    if (formats[cmp]) {
        return formats[cmp]({ value, conf, cmp });
    }
    // 不存在format函数时，默认转换逻辑 
    else {
        let previewValue = '';
        switch (fieldType) {
            // Select
            case __FIELD_TYPE_SELECT__:
                // 当下拉框为multipe时，value为逗号隔开的字符串【eg: 'option1,option2'】
                if (multiple) {
                    const labelArr = [];
                    value?.split(',').forEach(val => {
                        labelArr.push(dataSource?.find((item) => item.value === val)?.label);
                        previewValue = labelArr.join(',');
                    })
                }
                else {
                    previewValue = dataSource?.find((item) => item.value === value)?.label;
                }
                break;
            // Date
            case __FIELD_TYPE_DATE__:
                previewValue = value && new Dayjs(value).format("YYYY-MM-DD");
                break;
            default:
                previewValue = value;
                break;
        }
        return previewValue;
    }
};
const preview = (file) => {
  // usePreviewImage({ file });
  usePreviewFiles({ file });
};
</script>

<template>
  <div>
    <template v-if="state.conf.fieldType === __FIELD_TYPE_UPLOAD__">
      <div class="preview-content__field-label">
        {{ state.conf.label }}
      </div>
      <div
        v-for="(file, index) in state.value || []"
        :key="index"
        class="csr-upload__item"
        :class="{
          'csr-upload__item--error': file.status === 'error',
        }"
      >
        <p class="csr-upload__item-content">
          <i
            v-if="useBrand() === 'pelonisv2'"
            class="upload-iconpaperclip"
          />
          <i
            v-else
            class="iconfont-midea iconpaperclip"
          />
          <span
            :tltle="file.name"
            @click="preview(file)"
          >{{ file.name }}</span>
        </p>
      </div>
    </template>
    <!-- optIn preview 样式【特殊样式特殊处理】 -->
    <template v-else-if="state.cmp === __CMP_OPT_IN__">
      <MdCheckbox
        v-for="(item, index) in state.conf.termList"
        :key="index"
        style="margin-bottom: 20px"
        :value="state.value && state.value[index]?.checked === 'Y'"
      >
        <div v-html="item.label" />
      </MdCheckbox>
    </template>
    <!-- checkbox preview 样式【特殊样式特殊处理】 -->
    <template v-else-if="state.conf.fieldType === __FIELD_TYPE_CHECKBOX__">
      <MdCheckbox :value="state.value">
        <div v-html="state.conf.label" />
      </MdCheckbox>
    </template>
    <template v-else>
      <div class="preview-content__field-label">
        {{ state.conf.label }}
      </div>
      <div class="preview-content__field-value">
        {{ getValue(state) }}
      </div>
    </template>
  </div>
</template>
